import classnames from "classnames";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import Swal from "sweetalert2";
import ButtonBack from "../../Components/ButtonBack";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole";
import NavTabInfoProfileInfo from "../../Components/Tabs/NavTabInfoProfileInfo";
import EditEmployerModal from "../../Components/modals/GeneralModals/EditEmployerModal";
import { DASHBOARD_USER_ROLES, singularRoleLabels } from "../../constants";
import {
  cancelDeleteUsers,
  deleteUsers,
  getRoleById,
  loginAsUser,
} from "../../slices/admin/thunk";
import { downloadEntityReport } from "../../slices/general/thunk";
import { useCurrentUser } from "../../slices/auth/hooks";
import {
  authenticateWithTokenUser,
  capitalizeFirstLetter,
  formatDate,
} from "../../utils/utils";
import DashboardBilling from "../DashboardBilling/DashboardBilling";
import DashboardCommissions from "../DashboardCommissions/DashboardCommissions";
import DashboardIndividualBooks from "../DashboardIndividualBooks/DashboardIndividualBooks";
import DashboardEmployeesBroker from "./Brokers/DashboardEmployeesBroker";
import DashboardEmployersBroker from "./Brokers/DashboardEmployersBroker";
import DasboardEmployeesEmployer from "./Employers/DasboardEmployeesEmployer";
import DashboardBrokersGA from "./GA/DashboardBrokersGA";
import DashboardEmployeesGA from "./GA/DashboardEmployeesGA";
import DashboardEmployersGA from "./GA/DashboardEmployersGA";
import DashboardEmployersNational from "./Nationals/DashboarEmployersNational";
import DashboardBrokersNationals from "./Nationals/DashboardBrokersNational";
import DashboardEmployeesNational from "./Nationals/DashboardEmployeesNational";
import DashboardGaNational from "./Nationals/DashboardGaNational";
import CardDetails from "./components/CardDetails";
import { deleteUser } from "../../slices/general/thunk";
import CopyInviteLink from "../../Components/Buttons/CopyInviteLinkButton";
import UserSpecificCommissionModal from "../../Components/modals/AdminCommissionModal/UserSpecificCommissionModal";
import UserCustomPricingModal from "../../Components/modals/AdminCommissionModal/UserCustomPricingModal";
import EmployerCustomPricingModal from "../../Components/modals/AdminCommissionModal/EmployerCustomPricingModal";
import ManageUplineModal from "../../Components/modals/AdminModals/ManageUplineModal";

const ProfileInfoRole = () => {
  const params = useParams();
  const { id } = params;
  const [openEditModal, setOpenEditModal] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [userProfile, setUserProfile] = useState([]);
  const currentUser = useCurrentUser();
  // Modals states
  const [openModal, setopenModal] = useState(false);
  const [openUserSpecificCommissionModal, setOpenUserSpecificCommissionModal] = useState(false);
  const [openUserCustomPricingModal, setOpenUserCustomPricingModal] = useState(false);
  const [openEmployerCustomPricingModal, setOpenEmployerCustomPricingModal] = useState(false);
  const [openManageUplineModal, setOpenManageUplineModal] = useState(false);

  const isCurrentUserAdmin = currentUser?.role === DASHBOARD_USER_ROLES.ADMIN;
  const isCurrentUserNational = currentUser?.role === DASHBOARD_USER_ROLES.NATIONAL;
  const isCurrentUserNationalOrGA =
    currentUser?.role === DASHBOARD_USER_ROLES.GA ||
    isCurrentUserNational;

  const profileRole = userProfile.role;

  // To resolve name to send in requests, to get the profile info.
  const roleQuery =
    params.role === "brokers"
      ? DASHBOARD_USER_ROLES.BROKER
      : params.role === "employers"
        ? DASHBOARD_USER_ROLES.EMPLOYER
        : params.role === DASHBOARD_USER_ROLES.GA
          ? DASHBOARD_USER_ROLES.GA
          : DASHBOARD_USER_ROLES.NATIONAL
            ? "nationals"
            : "";

  const [isLoaded, setIsLoaded] = useState(false);

  const [activeTab, setActiveTab] = useState("1");

  const [employees, setEmployees] = useState(false);

  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setEmployees(status === "employees");
    }
  };

  const handleEditClick = () => {
    setOpenEditModal(true);
  };

  // #region Use Effects / API CALLS
  useEffect(() => {
    const initialize = async () => {
      try {
        setLoading(true);

        const user = await fetchUserProfile();

        if (!user) {
          // Navigate to dashboard
          navigate("/profile");
        }

        setUserProfile(user);
        setLoading(false);
      } catch (error) {
        setLoading(true);
        console.log(error);
        setLoading(false);
      }
    };

    if (!id) {
      // Navigate to dashboard
      navigate("/profile");
    } else {
      initialize();
    }
  }, [id]);

  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRoleById({ role: roleQuery, id })
      ).unwrap();
      setUserProfile(response);
      setIsLoaded(true);
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  const handleDeleteUsers = async (userId) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this user!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Swal loader
          Swal.fire({
            title: "Deleting...",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          });
          const response = await dispatch(deleteUser({ userId }));

          console.log("response", response);

          if (response === false) {
            Swal.fire("Error!", response.error, "error");
          } else {
            Swal.fire("Deleted!", "User has been deleted.", "success");

            // Navigate back.
            navigate(-1);
            // await fetchUserProfile();
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelDeleteUsers = async (userId) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to cancel the deletion of this user?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Cancelling...",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          });
          const response = await dispatch(cancelDeleteUsers({ userId }));

          console.log("response", response);

          if (response.error) {
            Swal.fire("Error!", response.error, "error");
          } else {
            Swal.fire(
              "Cancelled!",
              "User deletion has been cancelled.",
              "success"
            );
            await fetchUserProfile();
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleLoginAsUser = async (userId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You want to login as this user?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Logging in...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await dispatch(loginAsUser({ userId }));

        if (response.payload) {
          localStorage.setItem("tokenUser", response.payload.userAccessToken);
          localStorage.setItem("adminToken", response.payload.adminAccessToken);
          Swal.fire({
            title: "Success!",
            text: "Logged in as user.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          }).then(async (result) => {
            if (result.isConfirmed) {
              Swal.fire({
                title: "Reloading...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
            }
            const response = await authenticateWithTokenUser();
            if (response === true) {
              window.location.reload();
            } else {
              Swal.fire({
                title: "Error!",
                text: "An error occurred while trying to login as the user!",
                icon: "error",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        } else {
          Swal.fire("Error!", response.error, "error");
        }
      }
    } catch (error) {
      console.error("Login failed", error);
      Swal.fire("Error!", error.message, "error");
    }
  };

  // handles modals
  const handleToggleModal = () => {
    setopenModal(!openModal);
  };

  // Handle download entity report
  const handleDownloadReport = async (reportType) => {
    try {
      Swal.fire({
        title: "Downloading...",
        text: "Generating report, please wait.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await dispatch(
        downloadEntityReport({
          dashboardUserId: userProfile.id,
          reportType,
        })
      ).unwrap();

      // Create download link
      const url = window.URL.createObjectURL(response.blob);
      const link = document.createElement("a");
      link.href = url;
      const entityName = userProfile.companyName || `${userProfile.firstName || ""} ${userProfile.lastName || ""}`.trim() || "entity";
      link.download = `${entityName}-${reportType}-report.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        title: "Success!",
        text: "Report downloaded successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Download failed", error);
      Swal.fire({
        title: "Error",
        text: "Failed to download report.",
        icon: "error",
      });
    }
  };

  // #region RENDER FUNCTIONS
  const renderDropdownMenu = (item) => {
    return (
      <DropdownMenu>
        {userProfile.scheduledForDeletion ? (
          <DropdownItem
            onClick={() => {
              handleCancelDeleteUsers(item.id);
            }}
            className="remove-item-btn"
          >
            <i className="ri-close-fill align-bottom me-2 fw-bold text-muted"></i>
            Cancel Account Deletion
          </DropdownItem>
        ) : (
          <DropdownItem
            onClick={() => handleDeleteUsers(item.id)}
            className="edit-item-btn"
          >
            <i className="ri-delete-bin-6-fill align-bottom me-2 text-muted"></i>
            Delete
          </DropdownItem>
        )}

        {isCurrentUserAdmin && (
          <>
            <DropdownItem divider />
            <DropdownItem
              onClick={() => handleLoginAsUser(item.id)}
              className="edit-item-btn"
            >
              <i className="ri-user-fill align-bottom me-2 text-muted"></i>
              Login As
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem
              onClick={() => setOpenUserSpecificCommissionModal(true)}
              className="edit-item-btn"
            >
              <i className="ri-money-dollar-circle-line align-bottom me-2 text-muted"></i>
              Manage Commission Settings
            </DropdownItem>
            {profileRole === DASHBOARD_USER_ROLES.EMPLOYER ? (
              <DropdownItem
                onClick={() => setOpenEmployerCustomPricingModal(true)}
                className="edit-item-btn"
              >
                <i className="ri-price-tag-3-line align-bottom me-2 text-muted"></i>
                Manage Employee Pricing
              </DropdownItem>
            ) : (
              <DropdownItem
                onClick={() => setOpenUserCustomPricingModal(true)}
                className="edit-item-btn"
              >
                <i className="ri-price-tag-3-line align-bottom me-2 text-muted"></i>
                Manage Custom Pricing
              </DropdownItem>
            )}
            {/* Show Manage Custom Plans for nationals */}
            {profileRole === DASHBOARD_USER_ROLES.NATIONAL && (
              <DropdownItem
                onClick={() => navigate(`/admin/themes/national/${userProfile.id}/custom-plans`)}
                className="edit-item-btn"
              >
                <i className="ri-file-list-3-line align-bottom me-2 text-muted"></i>
                Manage Custom Plans
              </DropdownItem>
            )}
            {/* Only show Manage Upline for roles that have uplines */}
            {[DASHBOARD_USER_ROLES.GA, DASHBOARD_USER_ROLES.BROKER, DASHBOARD_USER_ROLES.EMPLOYER].includes(profileRole) && (
              <DropdownItem
                onClick={() => setOpenManageUplineModal(true)}
                className="edit-item-btn"
              >
                <i className="ri-organization-chart align-bottom me-2 text-muted"></i>
                Manage Upline
              </DropdownItem>
            )}
          </>
        )}

      </DropdownMenu>
    );
  };

  const renderProfileHeader = () => {
    // If user is broker, render name. Otherwise, company name.
    // Render it like: Role: Name
    // i.e "Broker: John Doe"

    const roleLabel =
      singularRoleLabels[profileRole] || capitalizeFirstLetter(profileRole);
    const name =
      profileRole === DASHBOARD_USER_ROLES.BROKER
        ? `${userProfile?.firstName || ""} ${userProfile?.lastName || ""
          }`.trim()
        : userProfile?.companyName || "";

    return (
      <div className="d-flex justify-content-left">
        <h5 className=" mb-0">
          <span className=" text-dark" style={{ whiteSpace: "nowrap" }}>
            {roleLabel}:
          </span>
        </h5>
        <h5 style={{ marginLeft: "0.5rem" }} className="text-dark mb-0">
          {name}
        </h5>
      </div>
    );
  };

  const renderNavLinkCommissions = (firstActiveTab, secondActiveTab) => {
    return isCurrentUserAdmin ? (
      <>
        <NavLink
          style={{ zIndex: 10 }}
          disabled={loading}
          className={classnames({
            "fw-semibold": activeTab === secondActiveTab,
            "active   p-2 text-primary": activeTab === secondActiveTab,
            "border-bottom border-2 border-primary":
              activeTab === secondActiveTab,
            " p-2 text-primary": activeTab !== secondActiveTab,
          })}
          onClick={() => {
            toggleTab(secondActiveTab, "individuals");
          }}
          href="#"
        >
          {" "}
          INDIVIDUALS
        </NavLink>
        <NavLink
          disabled={loading}
          className={classnames({
            "fw-semibold": activeTab === firstActiveTab,
            "active p-2 text-primary": activeTab === firstActiveTab,
            "border-bottom border-2 border-primary":
              activeTab === firstActiveTab,
            " p-2 text-primary": activeTab !== firstActiveTab,
          })}
          onClick={() => {
            toggleTab(firstActiveTab, "commission");
          }}
          href="#"
        >
          {" "}
          COMMISSIONS
        </NavLink>
      </>
    ) : isCurrentUserNationalOrGA ? (
      <NavLink
        style={{ zIndex: 10 }}
        disabled={loading}
        className={classnames({
          "fw-semibold": activeTab === secondActiveTab,
          "active  p-2 text-primary": activeTab === secondActiveTab,
          "border-bottom border-2 border-primary":
            activeTab === secondActiveTab,
          " p-2 text-primary": activeTab !== secondActiveTab,
        })}
        onClick={() => {
          toggleTab(secondActiveTab, "individuals");
        }}
        href="#"
      >
        {" "}
        INDIVIDUALS
      </NavLink>
    ) : null;
  };

  if (loading || !userProfile) {
    return (
      <div className="page-content">
        <div
          className="text-center d-flex justify-content-center align-items-center"
          style={{ minHeight: "150px", height: "150px" }}
        >
          <div className="spinner-border spinner-border-lg mr-3"></div>
        </div>
      </div>
    );
  }

  `BaxRx - Profile`;
  return (
    <React.Fragment>
      <div
        className="page-content
      d-flex flex-lg-row flex-column  
      "
      >
        {openEditModal && (
          <EditEmployerModal
            open={openEditModal}
            editUser={userProfile}
            setOpen={setOpenEditModal}
            setUser={setUserProfile}
            onRefreshTable={fetchUserProfile}
          />
        )}

        {/* Admin Commission Management Modal */}
        {isCurrentUserAdmin && (
          <UserSpecificCommissionModal
            isOpen={openUserSpecificCommissionModal}
            setIsOpen={setOpenUserSpecificCommissionModal}
            userProfile={userProfile}
            currentUser={currentUser}
            onRefresh={fetchUserProfile}
          />
        )}

        {/* Admin Custom Pricing Modal */}
        {isCurrentUserAdmin && (
          <UserCustomPricingModal
            isOpen={openUserCustomPricingModal}
            setIsOpen={setOpenUserCustomPricingModal}
            userProfile={userProfile}
            currentUser={currentUser}
            onRefresh={fetchUserProfile}
          />
        )}

        {/* Admin Employer Custom Pricing Modal */}
        {isCurrentUserAdmin && profileRole === DASHBOARD_USER_ROLES.EMPLOYER && (
          <EmployerCustomPricingModal
            isOpen={openEmployerCustomPricingModal}
            setIsOpen={setOpenEmployerCustomPricingModal}
            employerProfile={userProfile}
            currentUser={currentUser}
            onRefresh={fetchUserProfile}
          />
        )}

        {/* Admin Manage Upline Modal */}
        {isCurrentUserAdmin && (
          <ManageUplineModal
            isOpen={openManageUplineModal}
            setIsOpen={setOpenManageUplineModal}
            userProfile={userProfile}
            onRefresh={fetchUserProfile}
          />
        )}

        <Col md={12} sm={12} xs={12} lg={3} xl={3} className="me-1">
          <div className="">
            <Card className="p-3">
              <div className=" d-flex align-items-center mb-2 justify-content-between">
                <ButtonBack profileRole={roleQuery} />
                {(isCurrentUserAdmin ||
                  isCurrentUserNational)
                  ? (
                    <Col className="col-8 py-0 d-flex mb-0 justify-content-end gap-2">
                      <UncontrolledDropdown className="dropdown d-inline-block">
                        <DropdownToggle
                          tag="button"
                          className="btn btn-soft-primary fw-normal border border-primary btn-md"
                        >
                          Manage
                        </DropdownToggle>
                        {renderDropdownMenu(userProfile)}
                      </UncontrolledDropdown>
                      <UncontrolledDropdown className="dropdown d-inline-block">
                        <DropdownToggle
                          tag="button"
                          className="btn btn-soft-success fw-normal border border-success btn-md"
                        >
                          <i className="ri-download-2-line me-1"></i>
                          Reports
                        </DropdownToggle>
                        <DropdownMenu>
                          {isCurrentUserAdmin && profileRole === DASHBOARD_USER_ROLES.NATIONAL && (
                            <DropdownItem onClick={() => handleDownloadReport("gas")}>
                              <i className="ri-file-download-line me-2 text-muted"></i>
                              Download GAs Report
                            </DropdownItem>
                          )}
                          {[DASHBOARD_USER_ROLES.GA, DASHBOARD_USER_ROLES.NATIONAL].includes(profileRole) && (
                            <DropdownItem onClick={() => handleDownloadReport("brokers")}>
                              <i className="ri-file-download-line me-2 text-muted"></i>
                              Download Brokers Report
                            </DropdownItem>
                          )}
                          {[DASHBOARD_USER_ROLES.BROKER, DASHBOARD_USER_ROLES.GA, DASHBOARD_USER_ROLES.NATIONAL].includes(profileRole) && (
                            <DropdownItem onClick={() => handleDownloadReport("employers")}>
                              <i className="ri-file-download-line me-2 text-muted"></i>
                              Download Employers Report
                            </DropdownItem>
                          )}
                          <DropdownItem onClick={() => handleDownloadReport("employees")}>
                            <i className="ri-file-download-line me-2 text-muted"></i>
                            Download Employees Report
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </Col>
                  ) : null}
              </div>
              <div className="d-flex justify-content-end">
                {userProfile.scheduledForDeletion ? (
                  <p className="mb-1">
                    <span className="badge bg-danger">
                      Account will be deleted at{" "}
                      {formatDate(userProfile.deleteAt)}
                    </span>
                  </p>
                ) : null}
              </div>
              <div className="border rounded">
                <CardHeader className=" border-0 bg  bg-light">
                  {renderProfileHeader()}
                </CardHeader>
                <CardBody className=" mt-0 py-1">
                  <CardDetails
                    userProfile={userProfile}
                    currentUser={currentUser}
                    onRefresh={fetchUserProfile}
                  />
                </CardBody>
              </div>
            </Card>
          </div>
        </Col>
        <Col md={12} sm={12} xs={12} lg={9} xl={9} className="">
          {/* GA Role View */}
          {profileRole === DASHBOARD_USER_ROLES.GA && (
            <Card className="mb-4 pb-3">
              <div className="profile-nav-container">
                <NavTabInfoProfileInfo
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                  items={[
                    {
                      tab: "1",
                      value: "brokers",
                      label: "BROKERS",
                      disabled: loading,
                    },
                    {
                      tab: "2",
                      value: "employersGA",
                      label: "EMPLOYER GROUPS",
                      disabled: loading,
                    },
                    {
                      tab: "3",
                      value: "employeesGA",
                      label: "EMPLOYEES",
                      disabled: loading,
                    },
                  ]}
                  otherRender={() => renderNavLinkCommissions("4", "5")}
                />
              </div>

              {/* Action buttons */}
              {activeTab === "1" && (
                <div className="mt-3 d-flex justify-content-end pe-3">
                  <CopyInviteLink
                    role={DASHBOARD_USER_ROLES.BROKER}
                    inviteCode={userProfile.inviteCode}
                    className="me-2"
                  />
                  <ButtonAddRole
                    open={handleToggleModal}
                    roleToAdd="Broker"
                  />
                </div>
              )}

              {/* Content based on active tab */}
              <div className="mt-3">
                {activeTab === "1" ? (
                  <DashboardBrokersGA
                    isLoaded={isLoaded}
                    brokerId={userProfile.id}
                    openModal={openModal}
                    setOpenModal={setopenModal}
                  />
                ) : activeTab === "2" ? (
                  <DashboardEmployersGA
                    isLoaded={isLoaded}
                    employerId={userProfile.id}
                  />
                ) : activeTab === "3" ? (
                  <DashboardEmployeesGA
                    isLoaded={isLoaded}
                    employeeId={userProfile.id}
                  />
                ) : activeTab === "4" ? (
                  <DashboardCommissions />
                ) : (
                  <DashboardIndividualBooks user={userProfile} />
                )}
              </div>
            </Card>
          )}

          {/* EMPLOYER Role View */}
          {profileRole === DASHBOARD_USER_ROLES.EMPLOYER && (
            <Card className="mb-4 pb-3">
              <div className="profile-nav-container">
                <NavTabInfoProfileInfo
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                  items={[
                    {
                      tab: "1",
                      value: "employees",
                      label: "EMPLOYEES",
                      disabled: loading,
                    },
                    {
                      tab: "2",
                      value: "invoices",
                      label: "INVOICES",
                      disabled: loading,
                    },
                  ]}
                />
              </div>

              {/* Action buttons */}
              {activeTab === "1" && (
                <div className="mt-3 d-flex justify-content-end pe-3">
                  <ButtonAddRole
                    open={handleToggleModal}
                    roleToAdd="Employee"
                  />
                </div>
              )}

              {/* Content based on active tab */}
              <div className="mt-3">
                {activeTab === "1" ? (
                  <DasboardEmployeesEmployer
                    isLoaded={isLoaded}
                    employeeId={userProfile.id}
                    openModal={openModal}
                    setOpenModal={setopenModal}
                  />
                ) : (
                  <DashboardBilling />
                )}
              </div>
            </Card>
          )}

          {/* BROKER Role View */}
          {profileRole === DASHBOARD_USER_ROLES.BROKER && (
            <Card className="mb-4 pb-3">
              <div className="profile-nav-container">
                <NavTabInfoProfileInfo
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                  items={[
                    {
                      tab: "1",
                      value: "employers",
                      label: "EMPLOYER GROUPS",
                      disabled: loading,
                    },
                    {
                      tab: "2",
                      value: "employees",
                      label: "EMPLOYEES",
                      disabled: loading,
                    },
                  ]}
                  otherRender={() => renderNavLinkCommissions("3", "4")}
                />
              </div>

              {/* Action buttons */}
              {activeTab === "1" && (
                <div className="mt-3 d-flex justify-content-end pe-3">
                  <ButtonAddRole
                    open={handleToggleModal}
                    roleToAdd="Employer Group"
                  />
                </div>
              )}

              {/* Content based on active tab */}
              <div className="mt-3">
                {activeTab === "1" ? (
                  <DashboardEmployersBroker
                    isLoaded={isLoaded}
                    brokerId={userProfile.id}
                    openModal={openModal}
                    setOpenModal={setopenModal}
                  />
                ) : activeTab === "2" ? (
                  <DashboardEmployeesBroker
                    isLoaded={isLoaded}
                    employerId={userProfile.id}
                  />
                ) : activeTab === "3" ? (
                  <DashboardCommissions />
                ) : (
                  <DashboardIndividualBooks user={userProfile} />
                )}
              </div>
            </Card>
          )}

          {/* NATIONAL Role View */}
          {profileRole === DASHBOARD_USER_ROLES.NATIONAL && (
            <Card className="mb-4 pb-3">
              <div className="profile-nav-container">
                <NavTabInfoProfileInfo
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                  items={[
                    {
                      tab: "1",
                      value: "ga",
                      label: "GA",
                      disabled: loading,
                    },
                    {
                      tab: "2",
                      value: "brokers",
                      label: "BROKERS",
                      disabled: loading,
                    },
                    {
                      tab: "3",
                      value: "employers",
                      label: "EMPLOYER GROUPS",
                      disabled: loading,
                    },
                    {
                      tab: "4",
                      value: "employees",
                      label: "EMPLOYEES",
                      disabled: loading,
                    },
                  ]}
                  otherRender={() => renderNavLinkCommissions("5", "6")}
                />
              </div>

              {/* Action buttons */}
              {(activeTab === "1" || activeTab === "2") && (
                <div className="mt-3 d-flex justify-content-end pe-3">
                  <CopyInviteLink
                    role={activeTab === "1" ? DASHBOARD_USER_ROLES.GA : DASHBOARD_USER_ROLES.BROKER}
                    inviteCode={userProfile.inviteCode}
                    className="me-2"
                  />
                  <ButtonAddRole
                    open={handleToggleModal}
                    roleToAdd={activeTab === "1" ? "GA" : "Broker"}
                  />
                </div>
              )}

              {/* Content based on active tab */}
              <div className="mt-3">
                {activeTab === "1" ? (
                  <DashboardGaNational
                    isLoaded={isLoaded}
                    gaId={userProfile.id}
                    openModal={openModal}
                    setOpenModal={setopenModal}
                  />
                ) : activeTab === "2" ? (
                  <DashboardBrokersNationals
                    isLoaded={isLoaded}
                    brokerId={userProfile.id}
                    openModal={openModal}
                    setOpenModal={setopenModal}
                  />
                ) : activeTab === "3" ? (
                  <DashboardEmployersNational
                    isLoaded={isLoaded}
                    employerId={userProfile.id}
                  />
                ) : activeTab === "4" ? (
                  <DashboardEmployeesNational
                    isLoaded={isLoaded}
                    employeeId={userProfile.id}
                  />
                ) : activeTab === "5" ? (
                  <DashboardCommissions />
                ) : (
                  <DashboardIndividualBooks user={userProfile} />
                )}
              </div>
            </Card>
          )}
        </Col>
      </div>
    </React.Fragment>
  );
};

export default ProfileInfoRole;
